import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgLiveIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M9 8a4.992 4.992 0 0 0-2 4c0 1.636.786 3.088 2 4M15 16a4.993 4.993 0 0 0 2-4 4.993 4.993 0 0 0-2-4"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 20.064A9 9 0 0 1 3 12a9 9 0 0 1 4.873-8M16 4a9 9 0 0 1 5 8.065 9 9 0 0 1-4.873 8"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={12} cy={12} r={2} fill="currentColor" />
  </svg>
);

const ForwardRef = forwardRef(SvgLiveIcon);
const Memo = memo(ForwardRef);
export default Memo;
